export default "__VITE_ASSET__BW4gJkB9__"